import { store, history } from '@skunexus/redux';
import app from './config';

store.attachReducers(app.reducers.getAll());
store.runSagas(app.sagas.getAll());

export { history };
export default store;
